import { render, staticRenderFns } from "./BaseInputSearchAndClearButtons.vue?vue&type=template&id=b1c47800&scoped=true&"
import script from "./BaseInputSearchAndClearButtons.vue?vue&type=script&lang=js&"
export * from "./BaseInputSearchAndClearButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c47800",
  null
  
)

export default component.exports